import * as mapsApiLoader from '@googlemaps/js-api-loader'
import { PropType, defineComponent, onMounted, ref } from 'vue'

import { LocationCoordinates } from '../../ts/mapper/decoratedEstateDetailMapper.interface'

export default defineComponent({
    name: 'MsGoogleMaps',
    props: {
        apiKey: {
            type: String,
            required: true,
        },
        locationCoordinates: {
            type: Object as PropType<LocationCoordinates>,
            required: true,
        },
    },
    setup(props) {
        const mapWrapper = ref<null | HTMLElement>(null)
        const { Loader } = mapsApiLoader

        function createMap() {
            const loader = new Loader({ apiKey: props.apiKey })

            let map: google.maps.Map | null = null

            loader.importLibrary('maps').then(({ Map }): void => {
                if (mapWrapper.value) {
                    map = new Map(mapWrapper.value, {
                        center: { lat: props.locationCoordinates.lat, lng: props.locationCoordinates.long },
                        fullscreenControl: false,
                        streetViewControl: false,
                        zoom: 14,
                    })
                }
            })

            if (props.locationCoordinates.showPin) {
                loader.importLibrary('marker').then(({ Marker }): void => {
                    const marker = new Marker({
                        position: { lat: props.locationCoordinates.lat, lng: props.locationCoordinates.long },
                    })

                    marker.setMap(map)
                })
            }
        }

        onMounted(async () => {
            await createMap()
        })

        return {
            mapWrapper,
        }
    },
})
